<template>
  <div :class="['app-container', { 'bdc-list-page': isBdc }]">
    <!-- 工具栏 -->
    <div class="filter-container" :class="{ 'bdc-filter-bar': isBdc }">
      <el-button class="filter-item" v-if="isAdmin_Vip" type="primary" size="small" icon="el-icon-circle-plus-outline" @click="handleAdd">添加权限</el-button>
      <el-button class="filter-item" v-if="isAdmin_Vip" size="small" type="primary" icon="el-icon-connection" @click="piliangfenpeiquanxian" style="margin-left: 0px">批量分配权限</el-button>
      <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width:200px;"></el-input>
      <el-select class="filter-item" v-model="quanxianleixingvalue" size="small" placeholder>
        <el-option label="全部类型" value></el-option>
        <el-option label="系统权限" value="0"></el-option>
        <el-option label="自定义权限" value="1"></el-option>
      </el-select>
      <el-select class="filter-item" v-model="leixingvalue" size="small" placeholder>
        <el-option label="全部权限" value="-1"></el-option>
        <el-option v-for="item in purviewOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        <!-- <el-option label="渠道" value="4"></el-option> -->
      </el-select>
      <el-button class="filter-item" type="primary" size="small" @click="chaxunbtn1">查询</el-button>
      <!-- 表格header 筛选 -->
      <div class="filterTableHeader" style="float:right; margin-bottom: 10px" v-if="isAdmin_Vip && !isBdc">
        <el-popover width="400" trigger="click">
          <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div>
    </div>

    <!-- 表格 -->
    <div ref="bdcTableArea" :class="{'bdc-table-area': isBdc}">
    <el-table class="grayTableTile" size="small" v-loading="listLoading" :data="caseTable" border style="width: 100%" :height="tableHeightDaily">
      <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" :min-width="Object.keys(item)[0] == 'id' ? '60px' :'120px'">
        <template slot-scope="scope">
          <span v-if="Object.keys(item)[0] == 'permissionValue'" style="color:#646cf5;cursor: pointer;" @click="juesexiangqing(scope.row)">{{ scope.row[Object.keys(item)[0]]}}</span>
          <span v-else-if="Object.keys(item)[0] == 'type'">{{ scope.row[Object.keys(item)[0]] | yinyongleixing }}</span>
          <span v-else-if="Object.keys(item)[0] == 'status'">{{ scope.row[Object.keys(item)[0]] | statusType }}</span>
          <span v-else>{{ scope.row[Object.keys(item)[0]]}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="300">
        <template slot-scope="scope" v-if="isAdmin_Vip || scope.row['type'] == 1">
          <div class="bdc-table-op-cell">
            <el-button type="text" class="bdc-table-op-muted" @click="bianjijuese(scope.row)">编辑</el-button>
            <el-button type="text" class="bdc-table-op-danger" @click="shanchujuese(scope.row)">删除</el-button>
            <el-button type="text" class="bdc-table-op-muted" @click="tianjiaquanxian(scope.row)">添加角色引用</el-button>
          </div>
        </template>
      </el-table-column>

    </el-table>
    </div>

    <!-- 分页 -->
    <bdc-table-footer>
      <template v-if="isAdmin_Vip" #actions>
        <el-popover width="400" trigger="click">
          <bdc-column-filter-button slot="reference" />
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
            <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item">{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </template>
      <pagination v-show="total>0" :auto-scroll="false" :background="!isBdc" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" :class="isBdc ? 'bdc-table-pagination' : ''" @pagination="getList" />
    </bdc-table-footer>

    <!-- 添加 编辑权限 -->
    <el-dialog :title="formType == 'add' ? '添加权限信息' : '编辑权限信息'" v-if="addjuese" :visible.sync="addjuese" width="500px">
      <el-form ref="form" :model="form" :rules="formRules" label-width="80px">
        <el-form-item label="权限名称" prop="permissionValue">
          <el-input size="small" v-model="form.permissionValue" style="width:200px"></el-input>
        </el-form-item>

        <el-form-item label="显示名称" prop="name">
          <el-input size="small" v-model="form.name" style="width:200px"></el-input>
        </el-form-item>
      </el-form>

      <!-- 按钮组 -->
      <div class="dialog-butn-box" style="margin-top: 20px">
        <el-button size="small" type="primary" @click="handleSave">确认</el-button>
        <el-button size="small" @click="addjuese=false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <permis-info ref="info" @handleAddRoles="tianjiaquanxian"></permis-info>

    <!--右侧抽屉 穿梭框 添加分组 -->
    <transfer v-if="drawer" ref="transfer" :title="drawertitle" @getTransferList="getTransferList" @handleSave="handleSaveDrawer"></transfer>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcColumnFilterButton from '@/components/BdcTableFooter/BdcColumnFilterButton'
import { permissionlist, permissiondelete, permissionemerge, rolefilterHas, roledoAssignPermission, rolelist, permissionlistnew } from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'
import Transfer from './components/transferCollapse'
import PermisInfo from './components/permisInfo'
import bdcListTableHeight from '@Sys~/utils/bdcListTableHeight'

// table Header
const defaultFormThead = [
  { permissionValue: '权限名称' },
  { name: '显示名称' },
  { id: 'ID' },
  { type: '策略类型' },
  { status: '权限类型' },
  { roleSize: '被引用次数' }
]

// table 默认 header
const defaultChecked = [
  { permissionValue: '权限名称' },
  { name: '显示名称' },
  { type: '策略类型' },
  { status: '权限类型' },
  { roleSize: '被引用次数' }
]

// 弹窗默认的数据内容
const defaultFrom = {
  permissionValue: '', // 权限名称
  name: '', // 显示名称
}

export default {
  mixins: [bdcListTableHeight],
  components: { Pagination, BdcTableFooter, BdcColumnFilterButton, Transfer, PermisInfo },
  data() {
    return {
      search: '',
      quanxianleixingvalue: '',
      leixingvalue: "-1",
      purviewOptions: process.env.VUE_APP_PROJECT_TYPE == 'ads' ? [{ id: 2, name: '菜单' }, { id: 5, name: '媒体' }, { id: 6, name: '监测' }, { id: 7, name: '指标' }, { id: 8, name: '用户来源' }] : process.env.VUE_APP_PROJECT_TYPE == 'file' ? [{ id: 2, name: '菜单' }, { id: 1, name: '功能点' }, { id: 9, name: '部门' }, { id: 10, name: '外包商' }] : [{ id: 2, name: '菜单' }, { id: 4, name: '渠道' }, { id: 12, name: '国家维度' }],
      isAdmin_Vip: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('vip') > -1,

      // 表格
      listLoading: false,
      originalCaseTable: [],// 排序原始数据
      caseTable: [],
      tableTheadOptions: defaultFormThead,
      checkboxTitle: defaultFormThead.filter(item => !item.id),
      tableTheads: defaultChecked,

      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      // 创建 编辑权限
      formType: 'add',
      formRules: {
        permissionValue: [{ required: true, trigger: ['blur', 'change'], message: '请填写权限名称' }],
        name: [{ required: true, trigger: ['blur', 'change'], message: '请填写显示名称' }]
      },
      form: {},
      addjuese: false,

      // 右侧抽屉
      drawer: false,
      drawertitle: "",
      jueseinfo: {},
    }
  },
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    }
  },
  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
    }
  },

  filters: {
    yinyongleixing(value) {
      if (value == "0") {
        return "系统权限";
      } else if (value == "1") {
        return "自定义权限";
      }
    },

    statusType(type) {
      const typeMap = {
        2: '菜单',
        4: '渠道',
        5: '媒体',
        6: '监测',
        7: '指标',
        8: '用户来源',
        12: '国家维度'
      }
      return typeMap[type]
    }
  },

  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {

      var datas = {
        type: this.leixingvalue,//权限点分类 2:菜单,4:注册渠道,5:运营渠道
        status: this.quanxianleixingvalue,//类型
        queryWord: this.search,//模糊词
        pageNo: this.listQuery.pageNo,//
        pageSize: this.listQuery.pageSize,//
      }

      this.listLoading = true
      permissionlistnew(datas).then(response => {
        this.listLoading = false
        if (response.code == 1) {
          this.caseTable = response.data.result
          this.originalCaseTable = JSON.parse(JSON.stringify(this.caseTable))
          this.total = response.data.totalCount
        }
      })
    },

    chaxunbtn1() {
      this.listQuery.pageNo = 1;
      this.getList()
    },

    // 角色权限详情
    juesexiangqing(row) {
      this.$refs['info'].init(row)
    },

    // 添加权限
    handleAdd() {
      this.addjuese = true
      this.formType = 'add'
      this.form = JSON.parse(JSON.stringify(defaultFrom))
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    // 编辑
    bianjijuese(row) {
      this.addjuese = true
      this.formType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    // 确认 添加或编辑权限
    handleSave() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          permissionemerge(this.form).then(response => {
            if (response.code == 1) {
              this.$message({
                message: this.formType = 'add' ? "添加成功" : "编辑成功",
                type: "success"
              });
              this.getList();
              this.addjuese = false;
            }
          });
        }
      })
    },

    // 删除
    shanchujuese(row) {
      this.$confirm('确认删除角色： "' + row.name + '" 吗？').then(_ => {
        permissiondelete(row.id).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getList();
          }
        });
      }).catch(_ => { });
    },

    // 添加角色引用
    tianjiaquanxian(row) {
      this.drawer = true
      this.jueseinfo = row
      this.$nextTick(() => {
        this.drawertitle = "添加角色权限：" + row.name;
        this.$refs['transfer'].init("purview", row)
        this.$refs['transfer'].sourceList = [
          {
            title: '', // Collapse 折叠面板 标题
            name: '1', // Collapse 折叠面板 序号
            checkStrictly: true, // 不关联
            toSelectedList: { // 待选数据
              title: '待选', // 待选标题
              search: '',
              disabledSearch: true,
              treeload: true,
              list: []
            },
            selectedList: { // 已选数据
              title: '已选',
              search: '',
              disabledSearch: true,
              treeload: false,
              rawList: [],
              list: []
            }
          },
        ]
      })
    },

    // 批量分配权限
    piliangfenpeiquanxian() {
      this.drawer = true
      this.$nextTick(() => {
        this.drawertitle = "批量添加权限";
        this.$refs['transfer'].init("batch")
        if (process.env.VUE_APP_PROJECT_TYPE == 'ads') {
          this.$refs['transfer'].sourceList = [
            {
              title: '菜单', // Collapse 折叠面板 标题
              name: '1', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '媒体', // Collapse 折叠面板 标题
              name: '2', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            // {
            //     title: '监测', // Collapse 折叠面板 标题
            //     name: '3', // Collapse 折叠面板 序号
            //     checkStrictly: true, // true不关联 false关联
            //     source: 'batch-purview',
            //     toSelectedList:{ // 待选数据
            //         title: '待选', // 待选标题
            //         search:'', 
            //         disabledSearch: true,
            //         treeload: true,
            //         list:[]
            //     },
            //     selectedList: { // 已选数据
            //         title: '已选',
            //         search:'',
            //         disabledSearch: true,
            //         treeload: false,
            //         rawList:[],
            //         list:[]
            //     }
            // },
            {
              title: '指标', // Collapse 折叠面板 标题
              name: '4', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '用户来源', // Collapse 折叠面板 标题
              name: '6', // Collapse 折叠面板 序号
              checkStrictly: true, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '角色', // Collapse 折叠面板 标题
              name: '5', // Collapse 折叠面板 序号
              checkStrictly: true, // 关联
              source: 'purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },

          ]
        } else if (process.env.VUE_APP_PROJECT_TYPE == 'file') {
          this.$refs['transfer'].sourceList = [
            {
              title: '菜单', // Collapse 折叠面板 标题
              name: '1', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '功能点', // Collapse 折叠面板 标题
              name: '2', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },

            {
              title: '部门', // Collapse 折叠面板 标题
              name: '4', // Collapse 折叠面板 序号
              checkStrictly: true, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },

            {
              title: '外包商', // Collapse 折叠面板 标题
              name: '5', // Collapse 折叠面板 序号
              checkStrictly: true, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '角色', // Collapse 折叠面板 标题
              name: '3', // Collapse 折叠面板 序号
              checkStrictly: true, // 关联
              source: 'purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            }
          ]
        } else {
          this.$refs['transfer'].sourceList = [
            {
              title: '菜单', // Collapse 折叠面板 标题
              name: '1', // Collapse 折叠面板 序号
              checkStrictly: false, // 关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '渠道', // Collapse 折叠面板 标题
              name: '2', // Collapse 折叠面板 序号
              checkStrictly: true, // true不关联，false关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '国家维度', // Collapse 折叠面板 标题
              name: '3', // Collapse 折叠面板 序号
              checkStrictly: true, // true 不关联 false关联
              source: 'batch-purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            },
            {
              title: '角色', // Collapse 折叠面板 标题
              name: '4', // Collapse 折叠面板 序号
              checkStrictly: true, // 关联
              source: 'purview',
              toSelectedList: { // 待选数据
                title: '待选', // 待选标题
                search: '',
                disabledSearch: true,
                treeload: true,
                list: []
              },
              selectedList: { // 已选数据
                title: '已选',
                search: '',
                disabledSearch: true,
                treeload: false,
                rawList: [],
                list: []
              }
            }
          ]
        }
      })
    },

    // 权限筛选列表
    getTransferList(source, row, type) {
      if (source == "purview") {
        // 获取待选组列表 权限
        rolefilterHas(row.id).then(response => {
          this.$refs['transfer'].sourceList[0].toSelectedList.treeload = false
          if (response.code == 1) {
            if (response.data.length > 0) {
              this.$refs['transfer'].sourceList[0].toSelectedList.disabledSearch = false
            }
            this.$refs['transfer'].sourceList[0].toSelectedList.list = this.$refs['transfer'].transformList(response.data)
          }
        });
      } else {

        if (type) {
          // 获取权限列表
          permissionlist({ type: type }).then(response => {
            // 2:菜单,4:渠道，5:,媒体6:监测,7:指标，1:功能点  8：用户来源
            let index = type == 2 ? 0 : (type == 4 || type == 5 || type == 1) ? 1 : (type == 7 || type == 12 || type == 9) ? 2 : (type == 8 || type == 10) ? 3 : null
            this.$refs['transfer'].sourceList[index].toSelectedList.treeload = false
            if (response.code == 1) {
              if (response.data && response.data.length > 0) {
                this.$refs['transfer'].sourceList[index].toSelectedList.disabledSearch = false
              }
              this.$refs['transfer'].sourceList[index].toSelectedList.list = this.$refs['transfer'].transformList(response.data)
            }

          })
        } else {
          // 获取角色列表
          rolelist().then(response => {
            let index = null
            if (process.env.VUE_APP_PROJECT_TYPE == 'ads') {
              index = 4
            } if (process.env.VUE_APP_PROJECT_TYPE == 'file') {
              index = 4
            } else {
              index = 3
            }

            this.$refs['transfer'].sourceList[index].toSelectedList.treeload = false

            if (response.code == 1) {
              if (response.data.length > 0) {
                this.$refs['transfer'].sourceList[index].toSelectedList.disabledSearch = false
              }
              this.$refs['transfer'].sourceList[index].toSelectedList.list = this.$refs['transfer'].transformList(response.data)
            }
          });
        }
      }
    },

    // 确定添加 分组，添加权限
    handleSaveDrawer(list, row, source) {
      let data = []
      if (source == "purview") {
        let ids = []
        list[0].selectedList.list.forEach(item => {
          ids.push(item.id)
        })
        data = [{
          permissionIds: [row.id],
          roleId: ids
        }]
      } else {

        let rolesIds = []
        list[list.length - 1].selectedList.list.forEach(item => {
          rolesIds.push(item.id)
        })

        list.forEach((group, index) => {
          console.log(group)
          if (index < list.length - 1) {
            let ids = []
            group.selectedList.list.forEach(item => {
              ids.push(item.id)
            })
            console.log(index)
            data.push({
              permissionIds: ids,
              roleId: rolesIds,
              type: index == 0 ? 2 : index == 1 ? (process.env.VUE_APP_PROJECT_TYPE == 'ads' ? 5 : process.env.VUE_APP_PROJECT_TYPE == 'file' ? 1 : 4) : index == 2 ? (process.env.VUE_APP_PROJECT_TYPE == 'file' ? 9 : (process.env.VUE_APP_PROJECT_TYPE == 'ads' ? 6 : 12)) : index == 3 ? (process.env.VUE_APP_PROJECT_TYPE == 'file' ? 10 : 7) : index == 4 ? 8 : null
            })
          }
        })
      }
      // console.log(data)

      roledoAssignPermission(data).then(response => {
        this.$refs['transfer'].butnLoading = false;
        if (response.code == 1) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.$refs['transfer'].drawer = false
          this.drawer = false
          if (this.$refs['info'].juesequanxianlist) {
            this.$refs['info'].getList(row)
          } else {
            this.getList()
          }
        }
      });
    }
  }
}
</script>